import { DispositionType } from 'types/call.type';
import axiosInstance from './config/api';

export type CallDispositionResponse = {
    disposition: DispositionType;
};

export const putCallDisposition = async (callId: string, disposition: string) => {
    return axiosInstance
        .put<CallDispositionResponse>(`/calls/${callId}/disposition`, { disposition })
        .then((res) => res.data);
};
